export const BASE_URL = "https://pratdumas.com/admin/public/api/";
// export const BASE_URL = "http://localhost:8000/api/";

export const BASE_URL_PUBLIC = "https://pratdumas.com/admin/public/";

// export const BASE_URL_PUBLIC = "http://localhost:8000/"; // URL de ton environnement local Laravel

